import React from "react";

import { Field } from "formik";

// ui
import { Label, FormFeedback } from "reactstrap";
import CheckBox from "../Form/CheckBox";
import RequiredIndicator from "../Form/RequiredIndicator";

const CheckBoxGroup = (props) => {
	const { boxes, error, label, messageText, required } = props;

	const touchedBoxes = boxes.filter((box) => box.touched);
	const touched = touchedBoxes.length === boxes.length ? true : false;
	const invalid = required && error && touched ? true : false;

	const styles = {
		display: invalid ? "block" : "none",
	};

	const messageStyles = {
		fontSize: ".95rem",
	};

	return (
		<div>
			<Label>
				{label} {required && <RequiredIndicator />}
			</Label>
			{boxes.map((box) => (
				<Field key={box.fieldName} name={box.fieldName}>
					{({ field }) => (
						<CheckBox
							{...field}
							value={true}
							currentValue={box.currentValue}
							touched={touched}
							error={error}
							label={box.label}
							required
						/>
					)}
				</Field>
			))}
			<FormFeedback style={styles}>{error}</FormFeedback>
			<div style={messageStyles} className="mt-1">
				{messageText}
			</div>
		</div>
	);
};

export default CheckBoxGroup;
